export const byVolumeParamTooltips = {
  ratePercent: 'Потранзакционный расчет по указанному значению в процентном выражении',
  rateMin: 'Минимальное значение применяемое после расчета процентного выражения. Применяется если полученное процентное выражение меньше указанного значения',
  rateAbs: 'Постоянная величина прибавляемая к процентному или минимальному значению'
};
export const byTxFinTermParamTooltips = {
  rateAbs: 'Укажите числовое значение, для последующего потранзакционного расчета',
  minRate: 'Укажите минимальный платеж, применяемый после расчета финансового условия'
};